/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useState, useEffect } from "react";
import { Grid, Typography, makeStyles, IconButton, FormControl, Select, MenuItem, InputLabel, FormHelperText } from "@material-ui/core";
import { Done, Clear } from "@material-ui/icons";
import { InputField } from "../FormFields";
import Actions from "../../../fluid/Actions/ActionFactory";
import ErrorMessageAlert from "../../Utilities/ErrorMessageAlert";
import SecureWrapper from "../../Security/SecureWrapper";

const useStyles = makeStyles(() => ({
  mainContainer: {
    padding: "20px",
    overflow: "hidden",
  },
  topContainer: {
    background: "#FFFFFF",
    padding: "20px",
    margin: "10px 0px",
    boxShadow: "0px 3px 6px #00000029",
    height: "40%",
  },
  headerField: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
  titleText: {
    color: "#222222",
    fontSize: "18px",
    fontWeight: "bold",
  },
  formField: {
    width: "49%",
  },
}));

const EditRole = ({
  prevData,
  setIsEditRole,
  setIsTableUpdated,
  setisEdited,
}) => {
  const classes = useStyles();
  const [roleData, setRoleData] = useState(prevData);
  const [open, setopen] = useState(false);
  const [errmsg, seterrmsg] = useState(null);
  const [groups, setGroups] = useState([])
  const [groups_err, setGroupsErr] = useState("")

  useEffect(() => {
    setGroupsErr("")
    Actions('http_request', {
      url: "/sainapse/group",
      method : "get",
      data : {}
    }).then(res => {
      setGroupsErr("")
      setGroups(res.data.result)
    }).catch(err => {
      setGroups([])
      setGroupsErr(err.message)
    })
  },[])

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setRoleData({ ...roleData, [name]: value });
  };

  const handleGroupSelect = (group_name) => {
    setRoleData({...roleData, group_name: group_name})
  }

  const handleSubmit = () => {
    console.log("user...", roleData);
    const params = {
      name: roleData.name,
      group_name : roleData.group_name,
      description: roleData.description,
    };
    Actions("http_request", {
      url: "/sainapse/role/" + prevData.name + "/group/" + prevData.group_name,
      method: "put",
      data: params,
    })
      .then((res) => {
        console.log("res..1", res.data);
        setIsTableUpdated(true);
        setRoleData({ name: "", group_name : roleData.group_name, description: "" });
        setIsEditRole(false);
        setisEdited(true);
      })
      .catch((err) => {
        console.log("err..", err.message);
        setopen(true);
        seterrmsg(err);
      });
  };
  const onClose = () => {
    setopen(false);
    seterrmsg(null);
  };
  return (
    <Grid container className={classes.mainContainer}>
      <Grid container className={classes.topContainer}>
        <Grid item className={classes.headerField}>
          <div>
            <Typography className={classes.titleText}>Editing Role</Typography>
          </div>
          <div>
          <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/role/{name}/group/{group_name}",
                        method : "PUT",
                        operands : [
                          {
                            attrName: "name",
                            value : roleData.name
                      },
                      {
                          attrName: "group_name",
                          value : roleData.group_name
                      }]
                      }}
                  >
              <IconButton
                onClick={handleSubmit}
                style={{
                  color: roleData.name === "" ? "#62666e" : "#0CD02A",
                }}
                disableRipple={true}
                disabled={roleData.name === "" ? true : false}
              >
                <Done/>
              </IconButton>
            </SecureWrapper>
            <IconButton
              style={{
                color: "#FF0000",
              }}
              disableRipple={true}
              onClick={() => setIsEditRole(false)}
            >
              <Clear/>
            </IconButton>
          </div>
        </Grid>
        <Grid container justifyContent="space-between">
          <Grid item className={classes.formField}>
            <InputField
              name="name"
              size="small"
              placeholder="Name"
              autoComplete="off"
              value={roleData.name}
              onChange={handleChange}
              fullWidth
              disabled = {true}
              helperText={
                roleData.name === "" ? "Please provide a name for the Role" : ""
              }
              error={roleData.name === "" ? true : false}
            />
          </Grid>
        </Grid>
        <Grid container justifyContent="space-between">
          <Grid 
            item 
            className={classes.formField}
            style = {{width : '100%'}}
          >
            <FormControl
              fullWidth
              margin = 'dense'
            >
              <InputLabel>Select Group</InputLabel>
              <Select
                id="select"
                value={roleData.group_name}
                onChange={(e) => handleGroupSelect(e.target.value)}
                placeholder="Select"
                disabled={groups?.length === 0 && true}
                // renderValue={(selected) => {
                //   if (roleData.group_name === null) {
                //     return <em style={{ color: "#6F7070" }}>Select Group</em>;
                //   } else {
                //     return selected.name;
                //   }
                // }}
              >
                {groups?.map((item, index) => (
                  <MenuItem key={index} value={item.name}>
                    {item?.name ? item.name : "Unknown"}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>Select a group if you want this role to be group specific. If not select Global group.</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <InputField
            name="description"
            size="large"
            placeholder="Description"
            value={roleData?.description}
            onChange={handleChange}
            fullWidth
            multiline
            rows={8}
          />
        </Grid>
      </Grid>
      {open && (
        <ErrorMessageAlert
          open={open}
          errorInfo={errmsg}
          handleClose={onClose}
        />
      )}
    </Grid>
  );
};

export default EditRole;
